function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataanalysisRafiki(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.4,337.8H45.3a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,45.3,55H238.4a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,238.4,337.8ZM45.3,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H238.4a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.7,337.8H261.6a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,261.6,55H454.7a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,454.7,337.8ZM261.6,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H454.7a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.95,
    y: 124.28,
    width: 72.66,
    height: 92.07,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.19,
    y: 133.44,
    width: 58.19,
    height: 73.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.33,
    y: 124.28,
    width: 5.62,
    height: 92.07,
    transform: "translate(188.29 340.63) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.75,171.45A16.65,16.65,0,0,1,118.2,195C111.69,188.49,135.24,164.94,141.75,171.45Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.36,170.16a13.1,13.1,0,1,1,18.53-18.53C148,156.75,129.48,175.28,124.36,170.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.85,
    y: 253.72,
    width: 8.63,
    height: 129.28,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.73,
    y: 253.72,
    width: 7.51,
    height: 129.28,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.84,
    y: 253.72,
    width: 8.63,
    height: 129.28,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.72,
    y: 253.72,
    width: 7.51,
    height: 129.28,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.57,
    y: 253.72,
    width: 8.63,
    height: 129.28,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.44,
    y: 253.72,
    width: 7.51,
    height: 129.28,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.56,
    y: 253.72,
    width: 8.63,
    height: 129.28,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.85,
    y: 245.42,
    width: 132.11,
    height: 10.36,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.85,
    y: 245.42,
    width: 37.59,
    height: 10.36,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.44,
    y: 253.72,
    width: 7.51,
    height: 129.28,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.3,
    y: 246.08,
    width: 55.26,
    height: 136.92,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.5,
    y: 246.08,
    width: 115.43,
    height: 136.92,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.6,254.72h18.85a15,15,0,0,1,15,15V376.2a0,0,0,0,1,0,0H171.62a0,0,0,0,1,0,0V269.7A15,15,0,0,1,186.6,254.72Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.1,254.72H151a15,15,0,0,1,15,15V376.2a0,0,0,0,1,0,0H117.12a0,0,0,0,1,0,0V269.7A15,15,0,0,1,132.1,254.72Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.54,314.54a4.85,4.85,0,1,1-4.85-5.15A5,5,0,0,1,161.54,314.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.51,314.54a4.85,4.85,0,1,1-4.84-5.15A5,5,0,0,1,186.51,314.54Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-4",
    cx: 250,
    cy: 415.69,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Charts--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.47,260.38H310.16a5.74,5.74,0,0,1-5.81-6.37l3.84-43.92a7.1,7.1,0,0,1,6.93-6.38h71.31a5.75,5.75,0,0,1,5.82,6.38L388.4,254A7.09,7.09,0,0,1,381.47,260.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.45,228.5a12.94,12.94,0,0,1-12.65,11.63,10.48,10.48,0,0,1-10.61-11.63,13,13,0,0,1,12.65-11.62l.52-5.95a19.56,19.56,0,0,0-19.11,17.57,15.85,15.85,0,0,0,16,17.58,19.56,19.56,0,0,0,19.11-17.58Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.48,225.93a15.85,15.85,0,0,0-16-17.58l-.52,6a10.49,10.49,0,0,1,10.61,11.63Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.48,225.93a15.85,15.85,0,0,0-16-17.58l-.52,6a10.49,10.49,0,0,1,10.61,11.63Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.92,228.5a5.9,5.9,0,0,1-5.76,5.3,4.78,4.78,0,0,1-4.83-5.3,5.89,5.89,0,0,1,5.76-5.29l.23-2.7a8.9,8.9,0,0,0-8.69,8,7.21,7.21,0,0,0,7.29,8,8.9,8.9,0,0,0,8.7-8Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.92,228.5a5.9,5.9,0,0,1-5.76,5.3,4.78,4.78,0,0,1-4.83-5.3,5.89,5.89,0,0,1,5.76-5.29l.23-2.7a8.9,8.9,0,0,0-8.69,8,7.21,7.21,0,0,0,7.29,8,8.9,8.9,0,0,0,8.7-8Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.57,227.33a7.21,7.21,0,0,0-7.3-8L329,222a4.78,4.78,0,0,1,4.83,5.29Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.85,210.93l-.52,5.95a10.48,10.48,0,0,1,10.61,11.62,12.94,12.94,0,0,1-12.64,11.63,10.47,10.47,0,0,1-10.61-11.63,12.74,12.74,0,0,1,4.12-8.22l-3.83-4.2a19.27,19.27,0,0,0-6.24,12.42,15.85,15.85,0,0,0,16,17.58,19.57,19.57,0,0,0,19.11-17.58A15.85,15.85,0,0,0,370.85,210.93Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.85,210.93l-.52,5.95a10.48,10.48,0,0,1,10.61,11.62,12.94,12.94,0,0,1-12.64,11.63,10.47,10.47,0,0,1-10.61-11.63,12.74,12.74,0,0,1,4.12-8.22l-3.83-4.2a19.27,19.27,0,0,0-6.24,12.42,15.85,15.85,0,0,0,16,17.58,19.57,19.57,0,0,0,19.11-17.58A15.85,15.85,0,0,0,370.85,210.93Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.83,212.82l3.84,4.21a12.61,12.61,0,0,1,8.52-3.41h0l.52-5.94h0A19.11,19.11,0,0,0,356.83,212.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.83,212.82l3.84,4.21a12.61,12.61,0,0,1,8.52-3.41h0l.52-5.94h0A19.11,19.11,0,0,0,356.83,212.82Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.06,220l-.25,2.84a5,5,0,0,1,5.07,5.56,6.18,6.18,0,0,1-6,5.55,5,5,0,0,1-5.07-5.55,6.06,6.06,0,0,1,2-3.93l-1.83-2a9.21,9.21,0,0,0-3,5.94,7.56,7.56,0,0,0,7.66,8.39,9.34,9.34,0,0,0,9.13-8.39A7.57,7.57,0,0,0,370.06,220Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.36,220.86l1.83,2a6.1,6.1,0,0,1,4.08-1.63h0l.24-2.84h0A9.14,9.14,0,0,0,363.36,220.86Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.36,220.86l1.83,2a6.1,6.1,0,0,1,4.08-1.63h0l.24-2.84h0A9.14,9.14,0,0,0,363.36,220.86Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.18,253.77h0a1.69,1.69,0,0,1-1.71-1.87h0a2.08,2.08,0,0,1,2-1.87h0a1.69,1.69,0,0,1,1.71,1.87h0A2.09,2.09,0,0,1,318.18,253.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.36,252.85h-14a.85.85,0,0,1-.87-.95h0a1,1,0,0,1,1-1h14a.85.85,0,0,1,.87,1h0A1,1,0,0,1,337.36,252.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.51,256.6H323.05a.86.86,0,0,1-.87-1h0a1.06,1.06,0,0,1,1-1h10.47a.86.86,0,0,1,.87,1h0A1.07,1.07,0,0,1,333.51,256.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.72,253.77h0A1.69,1.69,0,0,1,357,251.9h0a2.08,2.08,0,0,1,2-1.87h0a1.69,1.69,0,0,1,1.71,1.87h0A2.09,2.09,0,0,1,358.72,253.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.9,252.85h-14a.86.86,0,0,1-.87-.95h0a1.06,1.06,0,0,1,1-1h14a.85.85,0,0,1,.87,1h0A1,1,0,0,1,377.9,252.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.05,256.6H363.59a.86.86,0,0,1-.87-1h0a1.06,1.06,0,0,1,1-1h10.47a.86.86,0,0,1,.87,1h0A1.07,1.07,0,0,1,374.05,256.6Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--graphic-2--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.41,284.33H182.58a5.75,5.75,0,0,1-5.82-6.37l5.94-67.87a7.1,7.1,0,0,1,6.93-6.38H296.47a5.75,5.75,0,0,1,5.81,6.38L296.35,278A7.1,7.1,0,0,1,289.41,284.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.41,284.33H182.58a5.75,5.75,0,0,1-5.82-6.37l5.94-67.87a7.1,7.1,0,0,1,6.93-6.38H296.47a5.75,5.75,0,0,1,5.81,6.38L296.35,278A7.1,7.1,0,0,1,289.41,284.33Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.04 264.04 184.33 264.04 187.96 222.56 190.67 222.56 187.04 264.04",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.89 264.04 188.17 264.04 190.84 233.53 193.56 233.53 190.89 264.04",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.99 264.04 194.28 264.04 196.02 244.1 198.73 244.1 196.99 264.04",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.83 264.04 198.12 264.04 200.2 240.26 202.91 240.26 200.83 264.04",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.94 264.04 204.22 264.04 207.32 228.6 210.04 228.6 206.94 264.04",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.78 264.04 208.06 264.04 210.74 233.53 213.45 233.53 210.78 264.04",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.88 264.04 214.17 264.04 216.84 233.53 219.55 233.53 216.88 264.04",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.72 264.04 218.01 264.04 221.35 225.84 224.06 225.84 220.72 264.04",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.83 264.04 224.11 264.04 225.93 243.3 228.64 243.3 226.83 264.04",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.67 264.04 227.96 264.04 230.63 233.53 233.34 233.53 230.67 264.04",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.77 264.04 234.06 264.04 237.16 228.6 239.87 228.6 236.77 264.04",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.62 264.04 237.9 264.04 241.66 221.04 244.38 221.04 240.62 264.04",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.72 264.04 244.01 264.04 244.99 252.75 247.71 252.75 246.72 264.04",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.56 264.04 247.85 264.04 249.68 243.14 252.39 243.14 250.56 264.04",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.66 264.04 253.95 264.04 255.7 244.1 258.41 244.1 256.66 264.04",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.51 264.04 257.79 264.04 261.22 224.88 263.93 224.88 260.51 264.04",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.61 264.04 263.9 264.04 266.15 238.34 268.86 238.34 266.61 264.04",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.45 264.04 267.74 264.04 272.09 214.31 274.8 214.31 270.45 264.04",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.56 264.04 273.84 264.04 276.76 230.65 279.48 230.65 276.56 264.04",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.4 264.04 277.69 264.04 280.36 233.53 283.07 233.53 280.4 264.04",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.5 264.04 283.79 264.04 287.47 222 290.18 222 286.5 264.04",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.34 264.04 287.63 264.04 289.8 239.3 292.51 239.3 290.34 264.04",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,275.36h0a2.4,2.4,0,0,1-2.44-2.66h0a3,3,0,0,1,2.9-2.67h0a2.4,2.4,0,0,1,2.44,2.67h0A3,3,0,0,1,186,275.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.29,274.05H193.4a1.22,1.22,0,0,1-1.24-1.35h0a1.52,1.52,0,0,1,1.48-1.36h19.89a1.23,1.23,0,0,1,1.24,1.36h0A1.51,1.51,0,0,1,213.29,274.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.83,279.39h-14.9A1.22,1.22,0,0,1,191.7,278h0a1.5,1.5,0,0,1,1.47-1.36h14.89A1.22,1.22,0,0,1,209.3,278h0A1.51,1.51,0,0,1,207.83,279.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.29,274.05H193.4a1.22,1.22,0,0,1-1.24-1.35h0a1.52,1.52,0,0,1,1.48-1.36h19.89a1.23,1.23,0,0,1,1.24,1.36h0A1.51,1.51,0,0,1,213.29,274.05Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.83,279.39h-14.9A1.22,1.22,0,0,1,191.7,278h0a1.5,1.5,0,0,1,1.47-1.36h14.89A1.22,1.22,0,0,1,209.3,278h0A1.51,1.51,0,0,1,207.83,279.39Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.34,275.36h0a2.41,2.41,0,0,1-2.44-2.66h0a3,3,0,0,1,2.9-2.67h0a2.4,2.4,0,0,1,2.44,2.67h0A3,3,0,0,1,225.34,275.36Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.34,275.36h0a2.41,2.41,0,0,1-2.44-2.66h0a3,3,0,0,1,2.9-2.67h0a2.4,2.4,0,0,1,2.44,2.67h0A3,3,0,0,1,225.34,275.36Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.62,274.05H232.73a1.22,1.22,0,0,1-1.24-1.35h0a1.52,1.52,0,0,1,1.48-1.36h19.89a1.23,1.23,0,0,1,1.24,1.36h0A1.51,1.51,0,0,1,252.62,274.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.16,279.39H232.27A1.22,1.22,0,0,1,231,278h0a1.5,1.5,0,0,1,1.47-1.36h14.89a1.22,1.22,0,0,1,1.24,1.36h0A1.5,1.5,0,0,1,247.16,279.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.62,274.05H232.73a1.22,1.22,0,0,1-1.24-1.35h0a1.52,1.52,0,0,1,1.48-1.36h19.89a1.23,1.23,0,0,1,1.24,1.36h0A1.51,1.51,0,0,1,252.62,274.05Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.16,279.39H232.27A1.22,1.22,0,0,1,231,278h0a1.5,1.5,0,0,1,1.47-1.36h14.89a1.22,1.22,0,0,1,1.24,1.36h0A1.5,1.5,0,0,1,247.16,279.39Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.67,275.36h0a2.4,2.4,0,0,1-2.43-2.66h0a3,3,0,0,1,2.9-2.67h0a2.4,2.4,0,0,1,2.43,2.67h0A3,3,0,0,1,264.67,275.36Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,274.05H272.06a1.21,1.21,0,0,1-1.23-1.35h0a1.5,1.5,0,0,1,1.47-1.36h19.89a1.23,1.23,0,0,1,1.24,1.36h0A1.51,1.51,0,0,1,292,274.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.49,279.39H271.6a1.22,1.22,0,0,1-1.24-1.36h0a1.5,1.5,0,0,1,1.47-1.36h14.9A1.22,1.22,0,0,1,288,278h0A1.5,1.5,0,0,1,286.49,279.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,274.05H272.06a1.21,1.21,0,0,1-1.23-1.35h0a1.5,1.5,0,0,1,1.47-1.36h19.89a1.23,1.23,0,0,1,1.24,1.36h0A1.51,1.51,0,0,1,292,274.05Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.49,279.39H271.6a1.22,1.22,0,0,1-1.24-1.36h0a1.5,1.5,0,0,1,1.47-1.36h14.9A1.22,1.22,0,0,1,288,278h0A1.5,1.5,0,0,1,286.49,279.39Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Information--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.76,197.33H335.64a5.75,5.75,0,0,1-5.82-6.37l3.3-37.73a7.09,7.09,0,0,1,6.93-6.37h62.12a5.75,5.75,0,0,1,5.82,6.37L404.69,191A7.09,7.09,0,0,1,397.76,197.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.49,169.67A12.81,12.81,0,0,1,350,181.17a10.37,10.37,0,0,1-10.49-11.5A12.79,12.79,0,0,1,352,158.17,10.37,10.37,0,0,1,362.49,169.67Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.49,169.67A12.81,12.81,0,0,1,350,181.17a10.37,10.37,0,0,1-10.49-11.5A12.79,12.79,0,0,1,352,158.17,10.37,10.37,0,0,1,362.49,169.67Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.47,167.63c-.22,2.52-1.18,4.56-3.7,4.56s-3.13-2-2.91-4.56,1.19-4.56,3.71-4.56S354.69,165.11,354.47,167.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.64,173.61c-5.27,0-8.13,1.17-9.48,2.89a10.38,10.38,0,0,0,8.82,4.67,12.63,12.63,0,0,0,9.64-4.67C358.57,174.78,355.92,173.61,350.64,173.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.58,156.83H370.91a1.42,1.42,0,0,1-1.44-1.58h0a1.76,1.76,0,0,1,1.72-1.58h18.67a1.42,1.42,0,0,1,1.44,1.58h0A1.75,1.75,0,0,1,389.58,156.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.56,168.5H369.89a1.42,1.42,0,0,1-1.44-1.58h0a1.77,1.77,0,0,1,1.72-1.59h24.67a1.43,1.43,0,0,1,1.44,1.59h0A1.75,1.75,0,0,1,394.56,168.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.05,174.33H369.38a1.42,1.42,0,0,1-1.44-1.58h0a1.76,1.76,0,0,1,1.72-1.58h29.67a1.42,1.42,0,0,1,1.44,1.58h0A1.75,1.75,0,0,1,399.05,174.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.54,180.17H368.87a1.43,1.43,0,0,1-1.44-1.59h0a1.77,1.77,0,0,1,1.72-1.58h27.67a1.42,1.42,0,0,1,1.44,1.58h0A1.76,1.76,0,0,1,396.54,180.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393,186H368.36a1.42,1.42,0,0,1-1.44-1.58h0a1.76,1.76,0,0,1,1.72-1.59h24.67a1.43,1.43,0,0,1,1.44,1.59h0A1.76,1.76,0,0,1,393,186Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.52,191.83H367.85a1.42,1.42,0,0,1-1.44-1.58h0a1.75,1.75,0,0,1,1.72-1.58H395.8a1.42,1.42,0,0,1,1.44,1.58h0A1.77,1.77,0,0,1,395.52,191.83Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--graphic-1--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317,197.33H210.15a5.75,5.75,0,0,1-5.82-6.37l5.94-67.88a7.09,7.09,0,0,1,6.93-6.37H324a5.74,5.74,0,0,1,5.81,6.37L323.92,191A7.1,7.1,0,0,1,317,197.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,197.33H210.15a5.75,5.75,0,0,1-5.82-6.37l5.94-67.88a7.09,7.09,0,0,1,6.93-6.37H324a5.74,5.74,0,0,1,5.81,6.37L323.92,191A7.1,7.1,0,0,1,317,197.33Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.61,148.72c-2.07-7.47-5.34-14.95-10.1-14.95-9,0-13.37,14.08-18,29-4.08,13.1-8.3,26.64-14.88,26.64-8.35,0-10.64-16.75-12.85-32.95-2.48-18.15-4.82-35.3-15.58-35.3s-16.09,17.15-21.75,35.3c-5.05,16.2-10.26,32.95-18.62,32.95-3.9,0-7.53-11.54-9.44-21.8l-.87,10c2.08,7.41,5.33,14.78,10.05,14.78,10.76,0,16.1-17.15,21.75-35.3,5-16.19,10.27-32.95,18.62-32.95s10.64,16.76,12.85,33c2.48,18.15,4.82,35.3,15.58,35.3,9,0,13.37-14.08,18-29,4.08-13.1,8.3-26.64,14.89-26.64,3.93,0,7.59,11.7,9.48,22Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 256.59,
    cy: 122.14,
    rx: 4.52,
    ry: 4.14,
    transform: "translate(-13.22 211.35) rotate(-43.75)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 256.59,
    cy: 122.14,
    rx: 2.24,
    ry: 2.06,
    transform: "translate(-13.22 211.37) rotate(-43.76)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.68,103.85h-15a3.22,3.22,0,0,0-3.14,2.88l-.24,2.74a2.6,2.6,0,0,0,2.63,2.88h5l1.49,2.25a1.06,1.06,0,0,0,1.7,0l1.88-2.25h5a3.21,3.21,0,0,0,3.13-2.88l.24-2.74A2.6,2.6,0,0,0,265.68,103.85Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.51,107.47H250.88a.67.67,0,0,1-.68-.75h0A.84.84,0,0,1,251,106h13.62a.68.68,0,0,1,.68.75h0A.82.82,0,0,1,264.51,107.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.88,110.19h-6.23a.68.68,0,0,1-.69-.75h0a.83.83,0,0,1,.82-.75H257a.67.67,0,0,1,.68.75h0A.84.84,0,0,1,256.88,110.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 283.96,
    cy: 188.98,
    rx: 4.52,
    ry: 4.14,
    transform: "translate(-51.84 248.84) rotate(-43.75)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.11,189a2.39,2.39,0,0,1-2.33,2.15,1.93,1.93,0,0,1-2-2.15,2.39,2.39,0,0,1,2.33-2.15A1.93,1.93,0,0,1,286.11,189Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.06,170.69h-15a3.21,3.21,0,0,0-3.13,2.88l-.24,2.73a2.6,2.6,0,0,0,2.63,2.89h4.95l1.49,2.25a1.08,1.08,0,0,0,1.71,0l1.88-2.25h4.95a3.21,3.21,0,0,0,3.14-2.89l.24-2.73A2.6,2.6,0,0,0,293.06,170.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.89,174.31H278.26a.67.67,0,0,1-.68-.75h0a.83.83,0,0,1,.81-.75H292a.68.68,0,0,1,.68.75h0A.82.82,0,0,1,291.89,174.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.26,177H278a.67.67,0,0,1-.68-.75h0a.84.84,0,0,1,.81-.75h6.24a.68.68,0,0,1,.69.75h0A.83.83,0,0,1,284.26,177Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.76,135a4.81,4.81,0,0,1-4.7,4.33,3.9,3.9,0,0,1-3.95-4.33,4.82,4.82,0,0,1,4.7-4.32A3.9,3.9,0,0,1,321.76,135Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.58,135a2.39,2.39,0,0,1-2.33,2.15,1.93,1.93,0,0,1-2-2.15,2.39,2.39,0,0,1,2.33-2.14A1.93,1.93,0,0,1,319.58,135Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.53,116.71h-15a3.21,3.21,0,0,0-3.14,2.88l-.24,2.74a2.6,2.6,0,0,0,2.63,2.88h5l1.49,2.25a1.06,1.06,0,0,0,1.7,0l1.88-2.25h4.95a3.21,3.21,0,0,0,3.14-2.88l.24-2.74A2.6,2.6,0,0,0,326.53,116.71Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.36,120.33H311.73a.67.67,0,0,1-.68-.75h0a.83.83,0,0,1,.81-.75h13.63a.68.68,0,0,1,.68.75h0A.82.82,0,0,1,325.36,120.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.73,123.05h-6.24a.68.68,0,0,1-.68-.75h0a.83.83,0,0,1,.82-.75h6.23a.68.68,0,0,1,.69.75h0A.84.84,0,0,1,317.73,123.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.24,189.48a4.81,4.81,0,0,1-4.7,4.32,3.9,3.9,0,0,1-3.94-4.32,4.81,4.81,0,0,1,4.7-4.33A3.9,3.9,0,0,1,221.24,189.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.07,189.48a2.39,2.39,0,0,1-2.34,2.14,1.94,1.94,0,0,1-2-2.14,2.4,2.4,0,0,1,2.34-2.15A1.94,1.94,0,0,1,219.07,189.48Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,171.18H211a3.22,3.22,0,0,0-3.14,2.88l-.23,2.74a2.59,2.59,0,0,0,2.63,2.88h5l1.49,2.25a1.06,1.06,0,0,0,1.7,0l1.89-2.25h5a3.22,3.22,0,0,0,3.14-2.88l.23-2.74A2.59,2.59,0,0,0,226,171.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.84,174.81H211.22a.68.68,0,0,1-.69-.75h0a.83.83,0,0,1,.82-.75H225a.68.68,0,0,1,.69.75h0A.84.84,0,0,1,224.84,174.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.22,177.52H211a.68.68,0,0,1-.68-.75h0a.82.82,0,0,1,.81-.75h6.24a.67.67,0,0,1,.68.75h0A.83.83,0,0,1,217.22,177.52Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.44,172.47l-2.88,5-2.83,5.13c-1.86,3.43-3.64,6.88-5.26,10.36-.81,1.74-1.58,3.47-2.28,5.22l-.13.31a.3.3,0,0,1,0,.08.55.55,0,0,0-.09.14,1.46,1.46,0,0,0-.13.28,1.9,1.9,0,0,0,.12,1.12,11.13,11.13,0,0,0,2.41,3.65,44.29,44.29,0,0,0,3.9,3.71l-2.34,5a24.5,24.5,0,0,1-3.23-1.14,25.29,25.29,0,0,1-3.06-1.57,17.3,17.3,0,0,1-5.63-5.23A11.52,11.52,0,0,1,125.2,200a10.74,10.74,0,0,1,0-2.72,9.72,9.72,0,0,1,.23-1.33l.16-.65.13-.39c.64-2.05,1.31-4.07,2.09-6a124.79,124.79,0,0,1,5.1-11.41c.93-1.85,1.9-3.68,2.92-5.47s2-3.56,3.19-5.39Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.72,206.93l5.26-1.37.3,8.49s-4.11.61-6.63-1.91Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.42 204.13 150.24 211.58 144.28 214.05 143.98 205.56 151.42 204.13",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.16,132.49c.11.58.52,1,.9.91s.59-.61.47-1.19-.52-1-.9-.91S173,131.91,173.16,132.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.62,133.49a21.38,21.38,0,0,0,3.79,4.4,3.42,3.42,0,0,1-2.67,1.09Z",
    style: {
      fill: "#ed847e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.38,129.7a.36.36,0,0,1-.24-.09.35.35,0,0,1,0-.49,3.46,3.46,0,0,1,3-1.16.35.35,0,0,1-.12.69h0a2.75,2.75,0,0,0-2.33.94A.36.36,0,0,1,170.38,129.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.62,140.66c1,5.37,2.1,15.22-1.66,18.81,0,0,1.47,5.45,11.46,5.45,11,0,5.24-5.45,5.24-5.45-6-1.43-5.83-5.88-4.79-10.06Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.79,160.46c-.8-1.49-1.68-3.2.15-3.73,2-.59,14.93-1.68,18.73-.58-1.17,2.08.81,4.63.81,4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.26,411a2.37,2.37,0,0,0,1.83-.1.71.71,0,0,0,.17-.81.79.79,0,0,0-.45-.51c-1-.48-3.27.45-3.37.49a.18.18,0,0,0-.1.16.15.15,0,0,0,.09.16A9.17,9.17,0,0,0,120.26,411Zm1.2-1.18.2.07a.47.47,0,0,1,.27.3c.09.31,0,.41-.07.44-.39.34-1.86,0-2.89-.39A5.84,5.84,0,0,1,121.46,409.84Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.47,410.42h.09c.83-.24,2.61-1.51,2.63-2.34a.57.57,0,0,0-.45-.56,1,1,0,0,0-.77.06c-1,.5-1.6,2.54-1.63,2.62a.16.16,0,0,0,0,.17A.14.14,0,0,0,118.47,410.42Zm2.08-2.6.08,0c.21.07.21.18.21.22,0,.49-1.19,1.48-2,1.89a4.22,4.22,0,0,1,1.34-2.07A.63.63,0,0,1,120.55,407.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.5,412.25c.94,0,1.85-.13,2.16-.55a.66.66,0,0,0,0-.77.86.86,0,0,0-.55-.4c-1.22-.33-3.79,1.13-3.9,1.19a.18.18,0,0,0-.08.18.17.17,0,0,0,.14.14A12.17,12.17,0,0,0,174.5,412.25Zm1.17-1.43a1.66,1.66,0,0,1,.33,0,.56.56,0,0,1,.34.25c.13.21.08.32,0,.38-.35.48-2.2.49-3.57.29A8.06,8.06,0,0,1,175.67,410.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.28,412.05l.07,0c.89-.4,2.65-2,2.51-2.82,0-.19-.17-.43-.65-.48a1.22,1.22,0,0,0-1,.3c-.94.76-1.13,2.74-1.14,2.83a.15.15,0,0,0,.07.15A.21.21,0,0,0,172.28,412.05Zm1.79-3h.11c.31,0,.33.16.34.2.08.5-1.12,1.75-2,2.29a4.1,4.1,0,0,1,1-2.27A.91.91,0,0,1,174.07,409.07Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.2 411.87 171.55 411.87 172.28 394.86 164.93 394.86 164.2 411.87",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.28 408.47 117.46 410.02 124.67 394.18 117.49 392.63 110.28 408.47",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.15,409.3l-8.06-1.74a.62.62,0,0,0-.72.36l-2.8,6.07a1.08,1.08,0,0,0,.77,1.51c2.83.56,4.23.69,7.78,1.46,2.18.47,7.11,1.67,10.12,2.32s4.06-2.24,2.88-2.78c-5.27-2.41-7.47-4.53-8.9-6.5A1.78,1.78,0,0,0,118.15,409.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.5,411h-8a.65.65,0,0,0-.63.5l-1.45,6.53a1.07,1.07,0,0,0,1.06,1.31c2.89-.05,7.07-.22,10.71-.22,4.25,0,7.93.23,12.92.23,3,0,3.85-3.05,2.59-3.32-5.75-1.26-10.44-1.39-15.41-4.46A3.44,3.44,0,0,0,171.5,411Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.81,161.13c-6.89,1.58-12.57,19.15-12.57,19.15l13.83,10.54a30.06,30.06,0,0,0,7.33-13.57C152.77,168,148.85,159.51,141.81,161.13Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.71,174.05c-3.74,3.7-5,10.44-5.25,16.3l.61.47a30.2,30.2,0,0,0,7.34-13.58c.14-.55.26-1.1.36-1.64Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,161.51s5.64,5.52,3.51,34.87c-.56,7.76-3.53,17.19-5.07,28.62H147.11c-.28-6,.51-35.45-5.3-63.87A102.56,102.56,0,0,1,155,159.47a145.27,145.27,0,0,1,16.7,0A73.5,73.5,0,0,1,183,161.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.94,186.08c-.65-4.26-1.34-8-2-11.2l-.22-.13-10.76,4.51c.52,6.69,7.59,13.44,12.51,17.39,0-.09,0-.19,0-.27C186.75,192.55,186.89,189.14,186.94,186.08Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.28 394.86 171.9 403.63 164.55 403.63 164.93 394.86 172.28 394.86",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.49 392.63 124.67 394.18 120.95 402.35 113.77 400.8 117.49 392.63",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.54,135.2c1.89,7,2.63,11.26,7,14.19,6.54,4.4,14.67-.65,14.93-8.12.23-6.72-2.9-17.11-10.45-18.52A9.94,9.94,0,0,0,153.54,135.2Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.46,225s-8.34,56.15-12.91,77.18c-5,23-31.89,99.24-31.89,99.24l-13.15-2.85s18.79-62.1,23-94.3c1.87-14.35,2.14-38.72,4.55-56.66A60.21,60.21,0,0,1,147.11,225Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.81,397s-2.45,4.75-2.45,4.75l-14.8-3.2,1.25-4.45Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.19,245c-9.64,1.89-8.62,37.84-7.46,56.33,2.78-13.07,6.85-38.22,9.63-56.07A3.29,3.29,0,0,0,164.19,245Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.4,225s3,54.93,2.21,77.33c-.83,23.31-9,99.6-9,99.6H162.2s-.46-74.93-1-97.82c-.61-24.95-3.62-79.11-3.62-79.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,397c.05,0-.71,5.16-.71,5.16H161.19l-.4-4.61Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.59,168.21c1.13,1.76,2.41,3.73,3.7,5.56s2.62,3.68,4,5.45A75.16,75.16,0,0,0,203,189c.77.71,1.56,1.37,2.36,2l.6.45a1.18,1.18,0,0,0-.35-.12c-.26-.05-.39,0-.32,0A3.34,3.34,0,0,0,207,191a19.85,19.85,0,0,0,2.53-1.31,87.15,87.15,0,0,0,10.56-8.19l4.29,3.47a51.09,51.09,0,0,1-9.61,11.73,24.11,24.11,0,0,1-3.44,2.53,13.41,13.41,0,0,1-5.05,1.87,8.57,8.57,0,0,1-5.76-1.22l-.87-.55q-1.71-1.11-3.27-2.34a72.85,72.85,0,0,1-10.77-10.81c-1.57-1.94-3.08-3.9-4.49-5.93s-2.77-4-4.09-6.32Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.16,172.62c-2.35,9.85,15.47,19.49,15.47,19.49l11.57-13.56a96.75,96.75,0,0,0-11.82-14.28C179.28,156.5,173.94,165.12,172.16,172.62Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.91,183.51l2.73-8.77,7.19,3.58s-1.05,6.4-6.28,7.51Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.52 172.31 231.01 174.09 228.83 178.32 221.64 174.74 224.52 172.31",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,145.58a10,10,0,0,0,7.6-7.66S167,133.7,170,130.83s1.52-6-1.48-6.59-7.6,3-7.6,3l-3.66,6.56,1.49,6.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,145.58a10,10,0,0,0,7.6-7.66S167,133.7,170,130.83s1.52-6-1.48-6.59-7.6,3-7.6,3l-3.66,6.56,1.49,6.62Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.52,135.49a8.23,8.23,0,0,0,3,4.39c1.91,1.42,3.34,0,3.2-2.14-.12-2-1.26-5-3.37-5.62S165,133.38,165.52,135.49Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,143.62c-1.79-4.27-5.09-15.32,6.57-19.38,0,0-.85-10.66,4.82-6.32,0,0-5.42-6.92-6.17.16,0,0-1.33-2.41.67-4,0,0-10.67-3.58-10.42,4.5a5.38,5.38,0,0,1,.75-5s-2.32-.14-3.24,3.52S145,120,145.83,128.33c0,0-8,10.06,11.21,18.65,0,0-2.53,1.56-1.09,4.05a6.65,6.65,0,0,1,3.42-4.05s-1.25,2.85,1.42,3.69a4.45,4.45,0,0,1,.79-4.39A2.5,2.5,0,0,0,162,143.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.87,148c-2.54.12-2.39,2.6-2.35,3a9.66,9.66,0,0,0,5.84-2.73C171.44,148.43,170.46,147.93,168.87,148Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.58,123.17s1.31-4.83,3.78-3.87.72,4.87,2,6.7a3.7,3.7,0,0,1-2.22-2.93c-.36-2.28-2.6,1.17-2.6,1.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.55 142.51 170.93 139.78 170.02 138.98 167.07 138.98 166.16 139.78 168.55 142.51",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.22 138.98 167.07 138.98 166.16 139.78 168.55 142.51 167.31 139.78 168.22 138.98",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataanalysisRafiki);
export default __webpack_public_path__ + "static/media/Data analysis-rafiki.34c357eccd7efbcc1e1a28a6a5d6d846.svg";
export { ForwardRef as ReactComponent };